/**
 * OCR patterns for Bangladeshi NID cards
 */

/**
 * NID number patterns
 */
export const NID_PATTERNS = {
  // Labeled NID patterns (with labels like ID NO, NID NO, etc.)
  LABELED: [
    /(?:ID\s*NO\s*[:\.]?\s*)(\d[\d\s]{9,16})/i,
    /(?:NID\s*NO\s*[:\.]?\s*)(\d[\d\s]{9,16})/i,
    /(?:নম্বর\s*[:\.]?\s*)(\d[\d\s]{9,16})/i,
    /(?:Number\s*[:\.]?\s*)(\d[\d\s]{9,16})/i,
    /(?:No\s*[:\.]?\s*)(\d[\d\s]{9,16})/i,
    /(?:nono\s*[:\.]?\s*)(\d[\d\s]{9,16})/i
  ],
  // Standalone NID patterns
  STANDALONE: /(?:^|\s)(\d[\d\s]{9,16})(?=\s|$)/gm,
  // Embedded NID patterns
  EMBEDDED: /(\d[\d\s]{9,16})/g
};

/**
 * Date of birth patterns
 */
export const DOB_PATTERNS = {
  MAIN: /(?:জন্ম তারিখ|জন্ম[:\s]*তারিখ|Date\s*of\s*Birth|DateofBith|DOB|Birth\s*Date|জন্ম)[:\s]*(\d{1,2}[-/]\d{1,2}[-/]\d{2,4}|\d{2,4}[-/]\d{1,2}[-/]\d{1,2}|\d{1,2}\s+[A-Za-z]{3}\s+\d{4})/i
};

/**
 * Name label patterns
 */
export const NAME_LABEL_PATTERNS = {
  FATHER: /(?:পিতার নাম|পিতার[:\s]*নাম|পিতা|Father['']?s\s*Name|Father['']?s|Father|পিতার)/i,
  MOTHER: /(?:মাতার নাম|মাতার[:\s]*নাম|মাতা|Mother['']?s\s*Name|Mother['']?s|Mother|মাতার)/i,
  NAME: /(?:নাম|Name|আপনার নাম)/i,
  NID: /(?:No\.|No\s*\.|নম্বর|NID\s*No|nono|ID\s*No|Number)/i,
  BLOOD_GROUP: /(?:Blood|গ্রুপ|Group)[:\s]*([ABO][\+\-]|O[\+\-]|AB[\+\-])/i
};

/**
 * English name patterns
 */
export const ENGLISH_NAME_PATTERNS = [
  // Smart card - "Name" label followed by uppercase name (including initials like MD.)
  /Name\s+([A-Z][A-Z\s\.]+?)(?=\s*[\u0980-\u09FF]|\s*পিতা|\s*মাতা|\s*Father|\s*Mother|\s*Date|\s*ID)/i,
  // Look for name with dots (S.M. Abdullah) - capture full name
  /([A-Z]\.[A-Z]\.\s+[A-Z][a-z]+(?:\s+[A-Z][a-z]+)*)/i,
  // Look for proper name after Bangla name
  /(?:[\u0980-\u09FF\s\.]+)([A-Z][a-z]+(?:\s+[A-Z][a-z]+)*)/i,
  // Look for name before father label
  /([A-Z][a-z]+(?:\s+[A-Z][a-z]+)*)(?=\s*পিতা|\s*মাতা)/i,
  // Look for name with initials (alternative pattern)
  /([A-Z]\.[A-Z]\.\s+[A-Z][a-z]+(?:\s+[A-Z][a-z]+)*)/i,
  // Smart card alternative - match any uppercase text after "Name" label
  /Name\s+([A-Z][A-Za-z\s\.]+?)(?=\s*[\u0980-\u09FF]|\s*পিতা|\s*মাতা|\s*Father|\s*Mother|\s*Date|\s*ID)/i,
  // Smart card - match any text after "Name" label (most flexible)
  /Name\s+([A-Za-z][A-Za-z\s\.]+)(?=\s*[\u0980-\u09FF]|\s*পিতা|\s*মাতা|\s*Father|\s*Mother|\s*Date|\s*ID)/i
];

/**
 * Bangla name patterns
 */
export const BANGLA_NAME_PATTERNS = [
  // Smart card - Bangla name before "Name" label
  /([\u0980-\u09FF\s\.]+?)(?=\s*Name\s*[A-Z])/i,
  // Analog card - "নাম:" followed by Bangla text
  /নাম[:\s]+([\u0980-\u09FF\s\.]+?)(?=\s*[A-Za-z0-9]|\s*[A-Z]{2,}|\s*পিতা|\s*মাতা|\s*Date|\s*ID)/i,
  // Fallback - extract Bangla text before English name
  /([\u0980-\u09FF\s\.]+?)(?=\s*[A-Z]{2,}\s+[A-Z][a-z])/i
];

/**
 * Smart card father name pattern
 */
export const SMART_FATHER_PATTERN = /(?:[A-Z][A-Z\s\.]+)\s+([\u0980-\u09FF\s]+?)(?=\s*মাতা|\s*Mother)/i;

/**
 * Character patterns
 */
export const CHAR_PATTERNS = {
  BANGLA_TEXT: /[\u0980-\u09FF]+/,
  ENGLISH_NAME: /[A-Za-z][A-Za-z\s\.\-]+[A-Za-z]/
};

/**
 * False positive patterns to skip
 */
export const FALSE_POSITIVE_PATTERNS = {
  ENGLISH_NAME: /Government|Republic|Bangladesh|National|Card|Abdul an|sovement|sove/i,
  BANGLA_NAME: /গণপ্রজাতন্ত্রী|সরকার|বাংলাদেশ|জাতীয়|পরিচয়পত্র|Government|Republic/i,
  NID_NUMBER: /(?:the|of|সরকার)\s*\d{10,}/i
};

/**
 * Year pattern (to filter out years from NID numbers)
 */
export const YEAR_PATTERN = /^(19|20)\d{2}$/;
